export function useDatasetIpdPackageDoi() {
    const extractLatestDoiVersion = (concatenatedDois: string): string => {
        if (!concatenatedDois) {
            return concatenatedDois;
        }

        const urls = concatenatedDois.split(/%20|\s+/).filter(Boolean);
        if (urls.length <= 1) {
            return concatenatedDois;
        }

        const getVersion = (url: string): number => {
            const match = url.match(/\.(\d+)$/);
            return match ? Number(match[1]) : -1;
        };

        return urls.reduce((latest, url) => (getVersion(url) > getVersion(latest) ? url : latest));
    };

    return {
        extractLatestDoiVersion,
    };
}
